import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useState } from 'react';
import { useErrorMessages } from '../../../models/hooks/appStateHooks';
import { useSummarizeGoogleReviewMutation } from '../../../queries/GoogleBusiness/useSummarizeGoogleReviewMutation';
import { Button } from '../../components-v2/Button';
import { styleSheet } from './styles';

interface ReviewSummarizeActionProps {
	reviewId?: string;
	impersonationContext?: Api.IImpersonationContext;
	onSummarize: (summary: string) => void;
}

export const ReviewSummarizeAction = ({ reviewId, impersonationContext, onSummarize }: ReviewSummarizeActionProps) => {
	const errorMessages = useErrorMessages();
	const [error, setError] = useState<string | null>(null);

	const { mutate: summarize, isPending } = useSummarizeGoogleReviewMutation({
		onSuccess: data => {
			if (data.summary) {
				onSummarize(data.summary);
			} else {
				setError('AI returned an empty summary. Please shorten the review yourself.');
			}
		},
		onError: err => {
			errorMessages.pushApiError(err);
			setError('Failed to summarize the review. Please shorten it yourself.');
		},
	});

	const handleSummarize = () => {
		setError(null);
		if (reviewId) {
			summarize({ reviewId, impersonationContext });
		}
	};

	return (
		<div className={css(styleSheet.summarizeRow)}>
			{error && <p className={css(styleSheet.summarizeError)}>{error}</p>}

			{reviewId && (
				<Button
					variant='secondary'
					aria-label='Summarize with AI'
					onClick={handleSummarize}
					isLoading={isPending}
					disabled={isPending}
				>
					Summarize with AI
				</Button>
			)}
		</div>
	);
};
